<span
  #menuTrigger="matMenuTrigger"
  [matMenuTriggerFor]="menu"
  [style.left]="position[0] + 'px'"
  [style.top]="position[1] + 'px'"
  [style.position]="'absolute'"
>
  <mat-menu #menu="matMenu" yPosition="above">
    <button mat-menu-item (click)="executeAction()">
      {{ label$ | async }}
    </button>
  </mat-menu>
</span>
